import React from 'react';

import { HeaderTitle, Loader, Title, WithHeader } from 'components';
import { CartStepper } from 'components/CartStepper';
import { TableNumberBadge } from 'components/TableNumberBadge';
import { Container } from './BaseConfirmPayment.style';
import { useBaseConfirmPaymentVM } from './useBaseConfirmPaymentVM';

export type BaseConfirmPaymentProps = {
    children: React.ReactNode;
    isLoading?: boolean;
};

const BaseConfirmPayment: React.FunctionComponent<BaseConfirmPaymentProps> = ({
    children,
    isLoading,
}) => {
    const { isFetching, navigateBackToChoosePayment, tableNumber } = useBaseConfirmPaymentVM();

    return (
        <WithHeader
            isSticky={true}
            onClickBack={navigateBackToChoosePayment}
            disabledClickBack={isLoading}
            disabledClickLogo={isLoading}
            hasAccountButton={!isLoading}
        >
            <CartStepper />
            <Container>
                <HeaderTitle>
                    <Title text={'order_payment'} type={4} />
                    {tableNumber && <TableNumberBadge tableNumber={tableNumber} />}
                </HeaderTitle>
                {isFetching ? <Loader withContainer /> : children}
            </Container>
        </WithHeader>
    );
};

export default BaseConfirmPayment;
